/*
 * Copyright (c) 2024 metromorph softworks GmbH
 *
 * All rights reserved
 */

import * as React from "react";

import { useTranslation } from "react-i18next";

import AppContext from "../AppContext";

import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";

export default function FallbackScreen() {
    const { t } = useTranslation();
    const { home } = React.useContext(AppContext);

    return (
        <Container 
            sx={{
                textAlign: "center"
            }}
        >
            <Typography mt={4} variant="h4">{t("Ansicht nicht gefunden")}</Typography>
            <Typography mt={4}>
                {t("Die von Ihnen ausgewählte Ansicht konnte nicht geladen werden")}
            </Typography>
            <Box mt={1}>
                <Button onClick={home}>{t("Zur Eingangsseite")}</Button>
            </Box>
        </Container>
    );
}
